<div class="npdc-title">
  @if (application(); as app) {
    <h1 mat-dialog-title>Edit application token - {{ app.name }}</h1>
  } @else {
    <h1 mat-dialog-title>New application token</h1>
  }

  <div class="npdc-title__actions">
    @if (form.pristine) {
      <a mat-flat-button type="button" routerLink="/token">Close</a>
    } @else {
      <a mat-button type="button" routerLink="/token">Close</a>
    }
  </div>
</div>

<p>
  An application token will identify as your account and access level when interacting with the
  configured endpoints.
</p>

<form id="form" [formGroup]="form" (ngSubmit)="save()">
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input required matInput formControlName="name" />
    </mat-form-field>
  </p>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Endpoints</mat-label>
      <textarea
        rows="3"
        required
        formControlName="endpoints"
        matInput
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="5"
      ></textarea>
      <mat-hint
        >Newline separated list of endpoints in “METHOD HOST PATH” format. Wildcard * substitutes
        UUIDs, e.g.
        {{
          'DELETE example.com /dataset/545caaab-7feb-4012-9291-7cc51d6ca81a/attachment/*'
        }}</mat-hint
      >
    </mat-form-field>
  </p>
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Valid until</mat-label>
      <input formControlName="validUntil" matInput [matDatepicker]="picker" />
      <mat-hint>YYYY-MM-DD</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </p>

  <p class="npdc-form-actions">
    <button mat-flat-button type="submit" [disabled]="form.pristine || form.invalid">Save</button>
    @if (application()) {
      <button mat-stroked-button type="button" (click)="delete()">Delete</button>
    }
  </p>
</form>
